import { render, staticRenderFns } from "./ModalDialogHistorico.vue?vue&type=template&id=b9c31da0&"
import script from "./ModalDialogHistorico.vue?vue&type=script&lang=js&"
export * from "./ModalDialogHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports